/**************************************************
* NAVBAR
**************************************************/
/**
* which main menu should we display : borrower/lender
* @returns {STRING}
*/
const setMainMenu = () => {
 let mainMenu = Cookies.get('menu');
 const headerType = $('.navbar-main').data('header-type');

 if (!mainMenu || !isMenuExistsInWP(mainMenu)) {
   mainMenu = isMenuExistsInWP(headerType) ? headerType : 'lenders';
   Cookies.set('menu', mainMenu, {secure: 'secure'});

 } else if( headerType && isMenuExistsInWP(headerType) && (headerType !== mainMenu) ){
   mainMenu = headerType;
   Cookies.set('menu', mainMenu, {secure: 'secure'});
 }
 displayMainMenu(mainMenu);
 return mainMenu;
}

/**
 *
 * @param {*} menu
 */
const displayMainMenu = (menu) => {
  const menuElements = '.menu-' + menu;
  $('#switch-universes p' + menuElements).addClass('d-xl-flex');
  $('.top .primary.nav' + menuElements).addClass('d-xl-flex');
  $('.top .secondary .nav' + menuElements).removeClass('d-none');
  $('.side .primary.nav' + menuElements).removeClass('d-none');
  $('.side .secondary .nav' + menuElements).removeClass('d-none');
}

/**
* check wp menus
* @param {STRING} MenuName
* @returns {BOOL}
*/
const isMenuExistsInWP = (MenuName) => {
 const registeredMenus = $('.navbar-main').data('registered-menus');
 return registeredMenus.includes(MenuName);
}

const isSideMenuDisplayed = () => {
  const answer = (breakpoint.value === 'xl') ? false : true;

  return answer;
};

const getSubMenuHeight = (mainMenu, headerHeight) => {
  //- measure height for dropdown transition animation
  $('.top .menu-navbar-container .' + mainMenu).height('auto');
  $('.top .menu-navbar-container .' + mainMenu + ' ul.sub-menu').addClass('rel');
  const subMenuHeight = $('.top .menu-navbar-container .' + mainMenu).height();
  $('.top .menu-navbar-container .' + mainMenu).height(headerHeight);
  $('.top .menu-navbar-container .' + mainMenu + ' ul.sub-menu').removeClass('rel');

  return subMenuHeight;
}

//-check lenders login cookie

const isLoggedLender = () => {
  return Cookies.get('userName') ? true : false;
};

const setLendersCTA = (logged) => {
  $('.header-sign-in span').addClass('d-none');
  if(logged){
    $('.header-sign-in .logged').removeClass('d-none');
    $('.top .header-sign-up').addClass('disabled');
    $('.side .header-sign-up').addClass('d-none');
  }else{
    $('.header-sign-in .login').removeClass('d-none');
  }
}

const debounced = (func, timeout) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args) }, timeout);
  }
}


/*
* ON LOAD
*/
if( $('header.navbar-main').length ) {
  $(function(){
    /**
     * INIT HEADER
     */
    breakpoint.refreshValue();
    let mainMenu = setMainMenu();
    setLendersCTA();

    const headerHeight = $('nav.top').height();
    let subMenuHeight = getSubMenuHeight(mainMenu, headerHeight);

    const headerBackground = $('.navbar-main').data('header-bg');
    if(headerBackground === 'dark'){
      $('body').addClass('dark');
    }

    if($(document).scrollTop() === 0){
      $('body, header.navbar-main').addClass('init');
    }

    if( $('section#lender-header-signup').length === 0 ){
      $('.top .header-sign-up').addClass('show');
    }else{
      $('.top .header-sign-up').addClass('disabled');
    }

    $(window).resize(() => {
      closeTopMenu();
      closeSideMenu();
      setLendersCTA(isLoggedLender());
      subMenuHeight = getSubMenuHeight(mainMenu, headerHeight);
    });

    /**
     * SCROLLING BEHAVIOURS
    */
    /**
    * TOP MENU
    * manage switches between initial state to scrolling:
    * dark/light bg
    * from position 'absolute' to 'sticky' (allowing the menu to dropdown the same way in both states)
    */
    $(window).scroll(()=>{
      if($(document).scrollTop() > 0) {
        $('body, header.navbar-main, .top .header-sign-up').removeClass('init');
      }

    });
    $(window).scroll(()=>{
      if($(document).scrollTop() > $('.navbar-main').outerHeight() && !$('body').hasClass('expanded')) {
          $('header.navbar-main').addClass('shadow');
          $('header.navbar-main:not(.expanded) nav.top').addClass('narrow');
          $('header.navbar-main, #logo, .burger, a.switch, li.menu-item').removeClass('dark');
          if($('section#lender-header-signup').length !== 0 && !isLoggedLender() && !isSideMenuDisplayed()){
            $('.top .header-sign-up').addClass('show').removeClass('disabled');
          }

      //- back to init mode
      } else if($(document).scrollTop() === 0) {
        $('header.navbar-main').removeClass('shadow');
        $('header.navbar-main nav.top').removeClass('narrow');
        $('body, header.navbar-main').addClass('init');
        if(headerBackground === 'dark') {
          $('header.navbar-main, #logo, .burger, a.switch, li.menu-item').addClass('dark');
        }
        if( $('section#lender-header-signup').length !== 0 && !isSideMenuDisplayed()){
          $('.top .header-sign-up').removeClass('show').addClass('disabled init');
        }
      }
    });

    $('.navbar-main').on('mousewheel', function(e) {
      if(!isSideMenuDisplayed()){
        e.preventDefault();
      }

    });

    /**
     * EXPAND BEHAVIOURS
     */

    const closeTopMenu = () => {
      if(!isSideMenuDisplayed()){
        $('header.navbar-main').removeClass('expanded shadow');
        $('.top .menu-navbar-container .' + mainMenu).height(headerHeight);
        $('.top .menu-navbar-container .' + mainMenu + ' .sub-menu').addClass('invisible').removeClass('expanded');
        if($(document).scrollTop() > 0) {
          $('header.navbar-main:not(.expanded) nav.top').addClass('narrow');
        }
      }
    }

    const openTopMenu = (itemID) => {

      if(!isSideMenuDisplayed()){
        $('header.navbar-main').addClass('expanded shadow');
        $('.top .menu-navbar-container .' + mainMenu).height(subMenuHeight);
        $('.top .menu-navbar-container .' + mainMenu + ' .sub-menu').addClass('expanded invisible');
        $('.top .menu-navbar-container .' + mainMenu + ' #' + itemID + ' .sub-menu').removeClass('invisible');
        $('header.navbar-main nav.top').removeClass('narrow');
      }
    }

    // $('.navbar-main').on( "mouseenter click", function() {
    $('.top .menu-navbar-container > ul > li > a').on( "mouseenter click", function() {
      const itemID = $(this).parent().attr('id');
      if(!isSideMenuDisplayed()){
        openTopMenu(itemID);
      }
    });

    $('.navbar-main').on( "mouseleave", function() {
      if(!isSideMenuDisplayed()){
        closeTopMenu();
      }
    });

    $('body').on( "mousewheel", function() {
      if( !isSideMenuDisplayed() && !$('nav.top').hasClass('narrow') ){
        closeTopMenu();
      }

    });

    /**
     *
     * SIDE menu
     * */
    const openSideMenu = () => {
      $('body, header.navbar-main').addClass('expanded');
      $('header.navbar-main nav.top').removeClass('narrow');
      $('nav.side').addClass('show');
      $('.burger').removeClass('open').addClass('close');
    }

    const closeSideMenu = () => {
      $('body, header.navbar-main').removeClass('expanded');
      if($(document).scrollTop() > 0) {
        $('header.navbar-main:not(.expanded) nav.top').addClass('narrow');
      }
      $('nav.side').removeClass('show');
      $('.burger').addClass('open').removeClass('close');
    }

    $('#burger').on('click', () => {
      if($('.burger').hasClass('open')) {
        openSideMenu();
      }else if($('.burger').hasClass('close')) {
        closeSideMenu();
      }
    });

  });
}
